module.exports = __webpack_public_path__ + "img/2023030714480428788r.303a30b0.jpg";